import React, { Component } from 'react';
import { RedocStandalone } from 'redoc';

import empapiDocs from './empapiDocs.json';

function EmpapiDocs() {
    return (
        <div>
            <RedocStandalone spec={empapiDocs} options={{ scrollYOffset: 100 }} />
        </div>
    );
}

export default EmpapiDocs;
